import type { CreateUpdateFormConfigurationDto, FormConfigurationDto } from './form-configurations/models';
import { RestService, Rest } from '@abp/ng.core';
import type { PagedAndSortedResultRequestDto, PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FormConfigurationService {
  apiName = 'Default';
  

  create = (input: CreateUpdateFormConfigurationDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, FormConfigurationDto>({
      method: 'POST',
      url: '/api/app/form-configuration',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/app/form-configuration/${id}`,
    },
    { apiName: this.apiName,...config });
  

  get = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, FormConfigurationDto>({
      method: 'GET',
      url: `/api/app/form-configuration/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getList = (input: PagedAndSortedResultRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<FormConfigurationDto>>({
      method: 'GET',
      url: '/api/app/form-configuration',
      params: { sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  update = (id: string, input: CreateUpdateFormConfigurationDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, FormConfigurationDto>({
      method: 'PUT',
      url: `/api/app/form-configuration/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
